import script from "./PodcastFollowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PodcastFollowButton.vue?vue&type=script&setup=true&lang=ts"

import "./PodcastFollowButton.vue?vue&type=style&index=0&id=3e15aa4d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e15aa4d"]])

export default __exports__